import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
const BackButton = ({ href, replace, ...otherProps }) => {
    const { t } = useTranslation('shared');
    const navigate = useNavigate();
    return (_jsxs("button", { type: "button", ...otherProps, className: "btn secondary-action-btn btn-simple", onClick: () => (href ? navigate(href, { replace }) : navigate(-1)), children: [_jsx("i", { className: "fa-light fa-arrow-left" }), _jsx("span", { children: t('common.back') })] }));
};
export default BackButton;
